<template>
    <div class="pending-approval">
        <base-header class="pb-6">
            <b-row align-v="center" class="py-3">
                <b-col cols="6">
                    <h2 class="listing-title d-inline-block mb-0">Pending Approvals</h2>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">
            <PendingApprovalTable></PendingApprovalTable>
        </b-container>
    </div>
</template>

<script>
import { Tabs, TabPane } from 'element-ui'
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import PendingApprovalTable from './PendingApprovalTable.vue';

export default {
    components: {
    RouteBreadCrumb,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    PendingApprovalTable
},
    data() {
        return {
            backButton: false,
        };
    },
    methods: {
        closeModal(){
            this.modals.create_new = false;
        },
    }
}
</script>